module.exports = __webpack_public_path__ + "static/MSSPHeroimage-7816b4837c1328bc7efbba16b1de0934.png";